<template>
  <div>
    <h4>{{ data.title }}</h4>

    <div v-if="data.description">
      <h6 class="my-3">Вопрос:</h6>
      <quill-editor
        v-model="data.description"
        :options="editorOption"
        @focus="focus($event)"
      />
    </div>
  </div>
</template>
  
  <script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
    };
  },
  props: ["data"],
  components: {
    quillEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>